<template>
  <v-radio-group v-model="selectedSupplierType" row @change="$emit('input',$event)">
    <v-radio v-for="sType in supplierTypes" :key="sType" :label="sType" :value="sType"></v-radio>
  </v-radio-group>
</template>

<script>
import { SUPPLIER_TYPES } from "../../../constants/supplierTypes";
export default {
  name: "SupplierTypeRadios",
  props: {
    value: {
      type: String,
      default: "ACCOMMODATION"
    }
  },
  data() {
    return {
      selectedSupplierType: this.value ? this.value : "ACCOMMODATION"
    };
  },
  watch: {
    value(newVal) {
      this.selectedSupplierType = newVal;
    }
  },
  computed: {
    supplierTypes() {
      return SUPPLIER_TYPES;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/SupplierTypeRadios.vue